<template>
	<div class="search-input-wrap">
		<div class="pt-10 pointer" @click="$refs.searchInput.focusInput()">
			<SVGIcon
				class="search-input-icon"
				:class="{ active: searchFocused || value }"
				icon-name="search"
				height="18"
				width="18"
			/>
		</div>
		<text-input
			ref="searchInput"
			class="w-full"
			type="search"
			:name="name"
			:value="value"
			:disabled="disabled"
			:focused.sync="searchFocused"
			:placeholder="placeholder"
			@input="updateValue"
			@enter="$emit('enter')"
		>
			<template #tip>
				<transition name="swipe-right">
					<slot name="append">
						<button v-if="value" class="search-input-close btn-ripple-effect" @click="clearValue">
							<SVGIcon icon-name="close" height="16" width="16" color="white" />
						</button>
					</slot>
				</transition>
			</template>
		</text-input>
	</div>
</template>

<script>
import { TextInput } from '~/components/interface'
import SVGIcon from '~/components/interface/SVGIcon'

export default {
	name: 'SearchInput',
	components: { SVGIcon, TextInput },
	props: {
		name: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		value: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({	searchFocused: false }),
	methods: {
		clearValue () {
			this.$emit('input', '')
		},
		updateValue (value) {
			this.$emit('input', value)
		}
	}
}
</script>

<style lang="scss">
.search-input-wrap {
	display: flex;
	align-items: center;

	.search-input-icon {
		will-change: transform;
		transform: translate(0, 0) scale(1);
		transition: 0.3s transform;

		&.active {
			transform: translate(5px, 2px) scale(0.8);
		}
	}

	.text-input {
		max-width: calc(100% - 30px);
	}

	.text-input-tip {
		max-width: 30px;

		.search-input-close {
			margin-top: 12px;
			cursor: pointer;
		}
	}

	.text-input-wrap .text-input {
		height: 40px;
		color: $white;
		background: transparent;
	}
}
</style>
